import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'

import NotificationQueue from '../../UI/NotificationQueue/NotificationQueue'
import Navigator from './Navigator/Navigator'
import ReduxLoader from './ReduxLoader/ReduxLoader'
import LoadComponents from './LoadComponents/LoadComponents'
import Render from './Render/Render'
import PageLoader from '../../UI/PageLoader/PageLoader'

const Layout = ({ config }) => {
  let location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <React.Fragment>
      <NotificationQueue />
      <LoadComponents />
      <Navigator />
      {!config.settings ? <PageLoader /> : <Outlet />}
      <ReduxLoader />
      <Render />
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(Layout)
